<template>
  <li class="flex gap-16">
    <div class="flex flex-col items-center">
      <RevAvatar
        class="bg-action-default-hi text-static-light-hi"
        :label="stepNumber"
        size="medium"
      />
      <RevDivider class="grow" variant="vertical" />
    </div>

    <div class="flex flex-col gap-4" :class="{ 'pb-32': !lastStep }">
      <div class="caption text-static-default-low">
        {{ i18n(translations.stepNumber, { stepNumber }) }}
      </div>
      <h2 class="heading-2">{{ stepTitle }}</h2>
      <div class="body-2 text-static-default-mid">{{ stepContent }}</div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAvatar } from '@ds/components/Avatar'
import { RevDivider } from '@ds/components/Divider'

import translations from './USRefurbProcessStep.translations'

const i18n = useI18n()

defineProps<{
  stepNumber: string
  stepTitle: string
  stepContent: string
  lastStep?: boolean
}>()
</script>
